import React from "react";
import { Empty, Form, Select } from "antd";
import { FormInstance } from "antd/lib/form/Form";
import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { EnumRole } from "@src/types/role";
import { useAllProducts } from "@src/hooks/use-all-products";
import { useMe } from "@src/hooks/use-me";
import { useTracking } from "react-tracking";
import { trackEventPayload } from "@src/util/track-event-payload";

export const ProductFilter: React.FC<{ form: FormInstance<any> }> = ({ form }) => {
  const { trackEvent } = useTracking();
  const { roles, isSuperAdmin } = useMe();

  const productCodesFiltered = roles.map((r: any) => r.productCode);
  const { products, isLoading } = useAllProducts({
    filters: !isSuperAdmin
      ? [
          {
            field: "code",
            operator: "in",
            value: productCodesFiltered,
          },
        ]
      : [],
    enabled: productCodesFiltered.length > 0,
  });
  const renderLabelProduct = (product: any) => {
    return (
      <div className="flex items-center">
        <img src={product.icon} className="w-4 h-4 rounded-[2px] mr-2" />
        {product.name} - {product.productCode}
      </div>
    );
  };

  const options = React.useMemo(() => {
    return products.map((product) => {
      const role = roles.find((r: { productCode: string }) => r.productCode === product.code);
      const disabled = !isSuperAdmin && role.role === EnumRole.ProductViewer;
      return {
        label: renderLabelProduct(product),
        value: product.code,
        pmpProductId: product.pmpProductId,
        title: product.name,
        disabled,
      };
    });
  }, [products]);

  const productCodeWatch = Form.useWatch(FilterFormFieldsEnum.PRODUCT_CODE, form);
  React.useEffect(() => {
    const record = products?.find((p) => p.code === productCodeWatch);
    form.setFieldsValue({
      [FilterFormFieldsEnum.PMP_PRODUCT_ID]: record?.pmpProductId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productCodeWatch, products]);
  return (
    <div>
      <Form.Item
        label="Product"
        name={FilterFormFieldsEnum.PRODUCT_CODE}
        required
        className="pb-2"
        rules={[{ required: true, message: "Please select product" }]}
      >
        <Select
          options={options}
          loading={isLoading}
          placeholder="Select product"
          showSearch
          filterOption={(input, option) => {
            const { title, value } = option as any;
            if (!value || !title) return false;
            return (
              title.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
              value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          allowClear
          style={{ width: 300 }}
          onChange={(value, opt: any) => {
            form.setFieldsValue({
              [FilterFormFieldsEnum.ABA_ID]: undefined,
              [FilterFormFieldsEnum.PMP_PRODUCT_ID]: opt?.pmpProductId,
            });
            trackEvent(trackEventPayload.generalInfoFieldUpdated({ name: "product", value: value }));
          }}
          notFoundContent={
            <Empty className="text-[12px]" description="You are not in product! Please contact your admin" />
          }
        />
      </Form.Item>
    </div>
  );
};
